import { render, staticRenderFns } from "./volunteer-name-team.vue?vue&type=template&id=34875078&"
import script from "./volunteer-name-team.vue?vue&type=script&lang=js&"
export * from "./volunteer-name-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports